module.exports = __webpack_public_path__ + "img/intro-sp-hagukumu.aaf66d14.jpg";